export default  {
    balanceList: '/api/web/v3/withdraw/balanceList',
    balanceDetail: '/api/web/v3/withdraw/balanceDetail'
}
